import { useCallback, useMemo, useState } from "react";
import { ModalStackProvider } from "@xsolla/xui-core";
import { ModalContext } from "./ModalContext";
import { ModalRoot } from "./ModalRoot";
import type { ModalProviderProps, ModalType } from "./types";

export const ModalProvider = ({ children, testID }: ModalProviderProps) => {
  const [modals, setModals] = useState<Record<string, ModalType>>({});

  const onOpenModal = useCallback(
    (key: string, modal: ModalType) =>
      setModals((m) => ({ ...m, [key]: modal })),
    []
  );

  const onCloseModal = useCallback(
    (key: string) =>
      setModals((m) => {
        if (!m[key]) return m;
        const newModals = { ...m };
        delete newModals[key];
        return newModals;
      }),
    []
  );

  const contextValue = useMemo(
    () => ({ onOpenModal, onCloseModal }),
    [onOpenModal, onCloseModal]
  );

  return (
    <ModalContext.Provider value={contextValue}>
      <ModalStackProvider value={Object.keys(modals).length}>
        {children}
        <ModalRoot modals={modals} testID={testID} />
      </ModalStackProvider>
    </ModalContext.Provider>
  );
};
